export class Position {
  Id: number;
  DisplayTitle: string;
}
